import React from 'react'
import {connect} from 'react-redux'
import * as ProjectsAction from '../actions/ProjectActions'
import ProjectRow from "../components/ProjectRow";
import {Button, Clearfix, Glyphicon} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import * as ClientsAction from "../actions/ClientActions";
import * as utils from "../utils";
import FirstTimeSetup from "../components/FirstTimeSetup";
import Loading from "../components/Loading";
import {needsSetup} from "../utils";

class ProjectsPage extends React.Component {

    componentWillMount() {
        this.loadData();
    }

    componentDidUpdate() {
        this.loadData();
    }

    loadData() {
        this.props.fetchProjectsIfNeeded();
        this.props.fetchClientsIfNeeded();
    }

    render() {
        const {projects, clients, tasks, needsSetup} = this.props;


        if(projects.fetching) return <Loading center loading />;
        if(needsSetup) return <FirstTimeSetup />;

        const clientArray = Object.values(clients.items).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        const projectArray = Object.values(projects.items);
        const taskArray = Object.values(tasks.items);
        
        return (
            <div>
                <div className="card" style={{marginBottom: "8px"}}>
                    <div className="card-heading">
                        <h1 className="card-title">
                            Projects
                            <NavLink to="/projects/add" className="pull-right">
                                <Button>
                                    <Glyphicon glyph="plus"/>&nbsp;
                                    <span className="hidden-xs">New</span> project
                                </Button>
                            </NavLink>
                            <NavLink to="/clients/add" className="pull-right" style={{marginRight: "10px"}}>
                                <Button>
                                    <Glyphicon glyph="plus"/>&nbsp;
                                    <span className="hidden-xs">New</span> client
                                </Button>
                            </NavLink>
                            <Clearfix />
                        </h1>
                    </div>
                </div>

                {
                    // projects.fetched &&
                    clients.fetched && clientArray.length > 0 &&
                    clientArray.map((client, i) => {
                        let rows = [];
                        projectArray.filter(project => project.client.id === client.id).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map((project, id) =>
                            rows.push(<ProjectRow key={project.id} project={project} hasTasks={taskArray.filter(task => task.project.id === project.id).length > 0} history={this.props.history}/>)
                        );
                        return (
                            <div className="card" key={client.id} style={i + 1 < clientArray.length ? {marginBottom: "8px"} : {}}>
                                <div className="card-heading">
                                    <h2 className="card-title">
                                        {client.name}
                                        <NavLink to={"/clients/" + client.id + "/edit"} className="pull-right" style={{marginRight: "10px"}}>
                                            <span className="hidden-xs">
                                                <Button bsStyle="default" bsSize="xsmall" >
                                                    <Glyphicon glyph="edit"/>
                                                    &nbsp;Edit client
                                                </Button>
                                            </span>
                                            <span className="visible-xs">
                                                <Glyphicon glyph="edit"/>
                                            </span>
                                        </NavLink>
                                    </h2>
                                </div>

                                {rows.length > 0 ? (
                                    <table className="table dark table-striped vertical-align-center">
                                        <thead>
                                        <tr className="entry-table-head">
                                            <th style={{width: 300}}>Project</th>
                                            <th style={{width: 200}}>Budget</th>
                                            <th style={{width: 200}}>Hours</th>
                                            <th/>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {rows}
                                        </tbody>
                                        <tfoot className="entry-table-footer">
                                        <tr>
                                            <td>Total</td>
                                            <td>{utils.formatHours(client.budgetMinutesTotal)}</td>
                                            <td>{utils.formatHours(client.minutesTotal)}</td>
                                            <th/>
                                        </tr>
                                        </tfoot>
                                    </table>
                                ) : (
                                    <div className="card-body" style={{textAlign: "center"}}><em>No projects have been added for {client.name} yet.</em></div>
                                )}
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default connect(state => ({
    projects: state.projects,
    clients: state.clients,
    tasks: state.tasks,
    needsSetup: needsSetup(state),
}), dispatch => ({
    fetchProjectsIfNeeded: () => dispatch(ProjectsAction.fetchProjectsIfNeeded()),
    fetchClientsIfNeeded: () => dispatch(ClientsAction.fetchClientsIfNeeded())
}))(ProjectsPage);


// WEBPACK FOOTER //
// ./src/pages/ProjectsPage.js